import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, makeStyles, Select, MenuItem } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { tenantPaymentBars } from "../sample";
import { ShaDowBox } from "../../../../../components/boxes";
import { GraphFooter, NoDataCard } from "../../../../../components/parts";
import { LabelBarChart } from "../../../../../components/charts";
import { getData, getPercent, sumFromList } from "../../../../../services";

const useStyles = makeStyles(() => ({
  box: {
    marginTop: 5,
    height: 240,
  },
  selectRoot: {
    fontSize: 18,
    padding: 0,
  },
}));

const graphItems = [
  {
    name: "Paying customers",
    color: COLORS.green,
  },
  {
    name: "Customer delays",
    suffix: "<1y",
    color: COLORS.red,
  },
  {
    name: "Customer delays",
    suffix: ">1y",
    color: COLORS.internationalOrange,
  },
];

const options = [
  {
    id: 0,
    label: "Tenants Payments",
  },
];

export const TenantPayments = ({ building, complex }) => {
  const classes = useStyles();
  const [chartData, setChartData] = useState([]);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  let url = `/praas/v1/buildings/payments/`;

  if (building?.id) {
    url = `/praas/v2/buildings/${building.id}/tenants/payments/`;
  } else if (complex?.id) {
    url = `/praas/v2/complexes/${complex.id}/tenants/payments/`;
  }

  useEffect(() => {
    getData(url, ({ portfolio, industry }) => {
      const totalInPortfolio = sumFromList(Object.values(portfolio));
      const payingPercentInPortfolio = getPercent(portfolio.paid, totalInPortfolio);
      if (totalInPortfolio) {
        setChartData([
          {
            name: "Portfolio",
            paying: payingPercentInPortfolio,
            delay: getPercent(portfolio.delay_less_year, totalInPortfolio),
            delays: getPercent(portfolio.delay_more_year, totalInPortfolio),
            label: `${payingPercentInPortfolio} %`,
          },
          {
            name: "Industry",
            paying: industry?.paid_percent,
            delay: industry?.delay_less_year_percent,
            delays: industry?.delay_more_year_percent,
            label: `${industry?.paid_percent || 0} %`,
          },
        ]);
      }
    });

    return () => setChartData([]);
  }, [building?.id, complex?.id, cluster, segments, selectedCountries]);

  if (!chartData.length) {
    return (
      <NoDataCard
        title="Tenants Payments"
        footerNames={["Paying customers", "Customer delays <1y", "Customer delays >1y"]}
      />
    );
  }

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Select
          labelId="label"
          id="select"
          defaultValue={options[0].id}
          autoWidth={true}
          onChange={null}
          disableUnderline
          classes={{ root: classes.selectRoot }}
        >
          {options.map((option, i) => (
            <MenuItem key={i} value={option.id} style={{ fontSize: 12 }}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        <Box className={classes.box}>
          <LabelBarChart
            top={110}
            bottom={30}
            height={240}
            chartData={chartData}
            bars={tenantPaymentBars}
            barSize={24}
            hideYAxis
            hideXAxis
            hideTooltip
            hideCartesianGrid
          />
        </Box>
        <GraphFooter
          style={{ marginTop: 13 }}
          items={graphItems}
          typographyStyle={{
            fontSize: 12,
          }}
        />
      </Box>
    </ShaDowBox>
  );
};
